import { Tag, TTagVariant } from "@/components/elements/Tag";
import { background, black, labelColor, state } from "@/theme/colors";
import { JOB_STATUS, TJobStatus } from "@/types/enum";
import { FC, useMemo } from "react";

export type TJobStatusTagProps = {
  status: string;
  title: string;
  variant: TTagVariant;
};

export const JobStatusTag: FC<TJobStatusTagProps> = ({ status, title, variant }) => {
  const commonStyleText = { "& .MuiTypography-root": { color: black[30], fontWeight: "400" } };

  type StatusConfig = { color: string; sx?: object };

  const STATUS_CONFIG: Record<TJobStatus, StatusConfig> = {
    [JOB_STATUS.DRAFT]: { color: background.disable, sx: commonStyleText },
    [JOB_STATUS.OPEN]: { color: labelColor.progress, sx: commonStyleText },
    [JOB_STATUS.SCHEDULED]: { color: labelColor.warning, sx: commonStyleText },
    [JOB_STATUS.PAUSED]: { color: state.error_3, sx: commonStyleText },
    [JOB_STATUS.CLOSED]: { color: labelColor.success, sx: commonStyleText },
  };

  const config = STATUS_CONFIG[status];

  const tagProps = useMemo<StatusConfig>(() => {
    return config ?? { color: background.disable };
  }, [status]);

  return <Tag variant={variant} {...tagProps} title={title} />;
};
